import React from 'react';
import { ExpertAdvisorMatcher } from '../components/advisors/ExpertAdvisorMatcher';

export const Advisors: React.FC = () => {
  return <ExpertAdvisorMatcher />;
};